<template lang="pug">
  .contact
    .contact__hearder
      img(
        @click="$router.push('/home')"
        src="@/assets/logo_blue.png"
      )
    .contact__content__container
      .title {{ $t('咨询合作') }}
      .contact__form
        el-form(
          v-model="data"
          ref="form"
          :model="data"
          :rules="rules"
          label-position="top"
        )
          el-form-item(
            :label="$t('姓名')"
            prop="name"
          )
            el-input(
              v-model="data.name"
              :placeholder="$t('姓名')"
            )
          el-form-item(
            :label="$t('联系电话')"
            prop="phone"
          )
            el-input(
              :placeholder="$t('联系电话')"
              v-model="data.phone"
            )
          el-form-item(
            :label="$t('公司')"
          )
            el-input(
              v-model="data.company"
              :placeholder="$t('公司')"
            )
          el-form-item(
            :label="$t('邮箱')"
          )
            el-input(
              :placeholder="$t('邮箱')"
              v-model="data.email"
            )
          el-form-item(
            :label="$t('需求')"
          )
            el-input(
              v-model="data.remark"
              :placeholder="$t('您希望针对哪方面进行咨询或合作')"
            )
      el-button(
        @click="onSubmit"
      ) {{ $t('提交') }}

</template>"

<script>
import axios from 'axios'
import { format4backend } from '@/util'
export default {
  data () {
    return {
      data: {
        name: '',
        phone: '',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('请输入姓名') }
        ],
        phone: [
          { required: true, message: this.$t('请输入联系电话') }
        ]
      }
    }
  },
  methods: {
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.onConfirm()
        }
      })
    },
    onConfirm () {
      let params = this.data
      params.from_url = this.$route.query.redirectUrl
      params.button_name = this.$route.query.buttonName
      params = {
        official_website_log: params
      }
      axios.post('/official/addNewOfficialWebsiteLog', format4backend(params))
        .then(res => {
          this.$alert('提交成功！我们将尽快与您联系。', {
            confirmButtonText: '确认',
            callback: action => {
              this.$message({
                type: 'info',
                message: `action: ${action}`
              })
            }
          })
        })
    }
  }
}
</script>

<style lang="stylus">
.el-message-box
  max-width 420px
  width auto

.contact
  @media (max-width: 767px)
    .el-form
      width 100%
    .el-button
      width 100%

  @media (max-width: 1370px) and (min-width: 768px)
    .el-form
      width 327px
      margin auto
    .el-input
      width 326px
    .el-button
      width 326px
  .contact__hearder
    height 74px
    border-bottom 1px solid rgba(151, 151, 151, 0.25)
    display flex
    align-items center
    justify-content center
    img
      width 210px
  .contact__content__container
    padding 0 24px  24px
  .title
    font-size 36px
    color $black-title
    text-align center
    margin 40px auto
  .contact__form
    display flex
    justify-content center
    align-items center
    margin auto
  .el-form
    .el-form-item__label
      font-size 16px !important
      color $black-title !important
      font-weight normal
  .el-input
    height 48px
    input
      height 42px
      width 100%
      line-height 42px
  .el-button
    background: linear-gradient(90deg,#4789c9,#75caff)
    border-radius 30px
    height 48px
    display flex
    align-items center
    justify-content center
    margin auto
    border-color transparent
    color #ffffff
    &:hover,&:focus
      color #ffffff
      background: linear-gradient(90deg,#4789c9,#75caff)
      border-color transparent
.el-message-box
  .el-message-box__btns
    .el-button
      width 50px !important
      padding 7px 10px !important
      height 32px
      border transparent
      color #ffffff
      &:hover,&:focus
        border-color transparent
        background #3370d2
</style>
